import React from 'react';

import Table from 'components/Table';
import Button from 'components/Button';

import './styles.css';

const getHasNoticeLabel = hasNotice => {
  if (hasNotice === true) return 'True';
  if (hasNotice === false) return 'False';

  return '-';
};

const BreakClauseTable = ({breakClause, openBreakClauseNoticeRecordModal}) => (
  <div className="BreakClauseTable">
    <Table>
      <Table.Header>
        <Table.HeaderItem heading="Period" className="period" />
        <Table.HeaderItem heading="Notice" className="noticePeriod" />
        <Table.HeaderItem heading="Type" className="type" />
        <Table.HeaderItem heading="Notice Given" className="hasNotice" />
        <Table.HeaderItem heading="Active Notice" className="hasActiveNotice" />
        <Table.HeaderItem heading="Notice Given Date" className="givenDate" />
        <Table.HeaderItem heading="Notice Recorded By" className="recordedBy" />
      </Table.Header>
      <Table.Body>
        {breakClause && (
          <Table.Row>
            <Table.Cell>{breakClause.period}</Table.Cell>
            <Table.Cell>{breakClause.noticePeriod}</Table.Cell>
            <Table.Cell>{breakClause.type}</Table.Cell>
            <Table.Cell>{getHasNoticeLabel(breakClause.hasNotice)}</Table.Cell>
            <Table.Cell>
              {getHasNoticeLabel(breakClause.hasActiveNotice)}
            </Table.Cell>
            <Table.Cell>{breakClause.noticeGivenDate || '-'}</Table.Cell>
            <Table.Cell>{breakClause.noticeRecordedBy || '-'}</Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
    </Table>
    <div className="options">
      {breakClause && (
        <Button white onClick={openBreakClauseNoticeRecordModal}>
          Record break clause notice
        </Button>
      )}
    </div>
  </div>
);

export default BreakClauseTable;
